import classNames from "classnames";
import React, { FC } from "react";
import { Link } from "react-router-dom";

export interface IListItemProps {
  active?: boolean;
  href?: string;
  onClick?: () => void;
}

export const ListItem: FC<IListItemProps> = ({ href, active, children, onClick }) => {
  const classes = classNames("list__item", { "list__item--active": active });

  return href ? (
    <Link className={classes} to={href} onClick={onClick}>
      {children}
    </Link>
  ) : (
    <div className={classes} onClick={onClick}>
      {children}
    </div>
  );
};
